import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import { GlobalConsumer } from 'site/context';
import { ContributePageConsumer } from '../context';
import ContributeSelectAmount from './select-amount';

const GET_CAMPAIGN = gql`
    query CampaignById($id: ID!) {
        campaign: campaignById(id: $id) {
            id
            name
            pledgePresets
            donatePresets
            metricName {
                singular
                plural
            }
            stats {
                performanceRemaining
            }
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        context: <ContributePageConsumer />,
        global: <GlobalConsumer />,
        campaignQuery: ({ context, render }) => (
            <Query query={GET_CAMPAIGN} variables={{ id: context.campaign.id }}>
                {render}
            </Query>
        ),
    },
    ({ context, campaignQuery, global }) => {
        const { campaign } = context;

        return {
            error: campaignQuery.error,
            loading: campaignQuery.loading,
            campaign: {
                ...campaign,
                ...get(campaignQuery, 'data.campaign', {}),
            },
            contribution: context.contribution,
            showFlash: global.showFlash,
        };
    }
);
/* eslint-disable react/prop-types, react/destructuring-assignment */

const ContributeSelectAmountContainer = ({ onSelect }) => (
    <Wrapper>
        {({ error, loading, campaign, contribution, showFlash }) => {
            if (error) throw error;
            if (loading) return null;

            const isPledge = contribution.type === 'pledge';

            return (
                <ContributeSelectAmount
                    onAmountSelect={onSelect}
                    name={campaign.name}
                    presets={isPledge ? campaign.pledgePresets : campaign.donatePresets}
                    performanceEstimate={get(campaign, 'stats.performanceRemaining')}
                    singularMetricName={get(campaign, 'metricName.singular')}
                    pluralMetricName={get(campaign, 'metricName.plural')}
                    isPledge={isPledge}
                    showFlash={showFlash}
                />
            );
        }}
    </Wrapper>
);

ContributeSelectAmountContainer.propTypes = {
    onSelect: PropTypes.func.isRequired,
};

export default ContributeSelectAmountContainer;
